import * as React from 'react';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';

// TODO: shims are not working in current version, and canShow is always true, we need to find shims for animations to make all loader animations work on all browsers
const polyfill = observable({
  canShowSvg: true,
  promise: undefined
});

const loadPolyFill = action(() => {
  if (polyfill.promise) {
    return polyfill.promise;
  }
  polyfill.promise = import('../../vendor/smill-in-javascript').then(() => {
    return import('../../vendor/web-animations').then(() => {
      polyfill.canShowSvg = true;
    });
  });
  return polyfill.promise;
});

export function animatedSvg<P>(C: React.ComponentClass<P>) {
  @observer
  class AnimatedSvgWrapper extends React.Component<P> {
    componentDidMount() {
      if (!polyfill.canShowSvg) {
        loadPolyFill();
      }
    }

    render() {
      if (polyfill.canShowSvg) {
        return <C {...this.props} />;
      }
      return null;
    }
  }

  return AnimatedSvgWrapper;
}
